import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import InstitutionProfile from "./profile";
import { withRouter } from "react-router-dom";
import Modal from "../../../utils/customModal";
import { withTranslation } from 'react-i18next';
import { getRoles } from "../../../../Redux/reducer/session";
import { MOD_CUSTOM, WRITE } from "../../../../permissions/";
import * as ClientActions from "../../../../Redux/actions/clientActions";
import { moduleAction, loadingHtml, errorContainer } from "../../../utils/functions";

export class SwitchEditClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: { show:true, content: loadingHtml(), onclose: undefined },
      type: "loading",
      institution: {},
      contentReady: false,
    };
  }

  componentDidMount() {
    const {
      t,
      match: { params },
      actions: { getInstitutionProfile },
    } = this.props;
    const { modal } = this.state;
    return getInstitutionProfile(params.id).then((response) => {
      this.setState({ institution: response.data, contentReady: true });
    }).catch(err => {
      var buttons = { continueBtn: { action: this.onCloseModal, text: t("general.buttons.close") } }

      if( err.response.data.notifications !== undefined ) {
        var notification = err.response.data.notifications[0];

        modal.content = errorContainer(notification.message, notification.description, buttons);
        modal.onclose = this.onCloseModal;
      } else {
        modal.content = errorContainer(t("general.labels.errorTitle"), t("general.labels.defaultError"), buttons);
        modal.onclose = this.onCloseModal;
      }
      this.setState({ modal });
    });
  }

  onCloseModal = () => {
    this.props.history.push(`/bscadministrator/home`);
  }

  componentWillUnmount() {
    this.setState({ institution: {} });
  }

  render() {
    const { institution, contentReady, modal } = this.state;
    const { roles } = this.props;
    const canEdit = moduleAction(roles, MOD_CUSTOM, WRITE);
    return (
      <div className="rate">
        {contentReady ? (
          <InstitutionProfile
            canEdit={canEdit}
            institution={institution}
          />
        ) : (
          <Modal show={modal.show} handleClose={modal.onclose}>{modal.content}</Modal>
        )}
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ClientActions, dispatch),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatch
  )(withTranslation()(SwitchEditClient))
);
